import { usePaymentCallbacksForProduct } from '@lingoda/payments';
import CheckoutForm from '../CheckoutForm';
import type { ContainerCommonProps } from './types';

type Props = ContainerCommonProps;

const CheckoutProduct = ({
    asyncValidating,
    purchase,
    submitLabel,
    terms,
    testChargeLabel,
}: Props) => {
    const [handlePaymentSubmit, fetchIntentSecret] = usePaymentCallbacksForProduct(purchase);

    return (
        <CheckoutForm
            purchase={purchase}
            onSubmitPaymentCallback={handlePaymentSubmit}
            fetchIntentSecretCallback={fetchIntentSecret}
            asyncValidating={asyncValidating}
            submitLabel={submitLabel}
            terms={terms}
            testChargeLabel={testChargeLabel}
        />
    );
};

export default CheckoutProduct;
